import React, { useMemo } from 'react';
import { Switch, Route, useLocation, Router } from 'react-router-dom';
import BasicRedirect from './views/routes/components/BasicRedirect';
import BasicRoute from './views/routes/components/BasicRoute';
import { ErrorBoundary } from 'react-error-boundary';
import BicesterFrameLayout from '@/components/layouts/BicesterFrameLayout';
import NotFound, { ThrowNotFound } from '@/views/_404';
import ErrorView from '@/views/_error';
import history from '@/utils/history';
// Pre-load pages
import Login from '@/views/auth/login';
import { useReadyInfo } from './providers/ReadyProvider';
import BicesterNavbar from './components/layouts/BicesterNavbar';
import renderRoutes from './views/routes/utils/renderRoutes';
import { roleRouters } from './views/routes';

/**
 * 登录后可访问的路由
 */
function ProtectedRoutes() {
  const { pathname } = useLocation();
  const { profile } = useReadyInfo();

  const routes = useMemo(() => {
    const authRoutes = roleRouters[profile?.role];
    return authRoutes;
  }, [profile]);

  return (
    <ErrorBoundary FallbackComponent={NotFound} resetKeys={[pathname]}>
      <BicesterFrameLayout>
        <BicesterNavbar />
        <Router history={history}>
          <Switch>
            {renderRoutes(routes)}
            <BasicRoute component={ThrowNotFound} />
          </Switch>
        </Router>
      </BicesterFrameLayout>
    </ErrorBoundary>
  );
}

/**
 * 认证路由，用于登录、注册等
 */
function AuthRoutes() {
  const { profile } = useReadyInfo();

  return (
    <Switch>
      {profile && <BasicRedirect to="/customer-account/list" />}
      <BasicRoute path="/login" exact component={Login} />
      <BasicRedirect to="/login" />
    </Switch>
  );
}

/**
 * 游客重定向至登录页
 */
function GuestFallback() {
  return <BasicRedirect to="/login" />;
}

/**
 * 利用 <Switch> 自上而下匹配的机制
 * 1、公共路由，即游客/成员均可访问，每个都要声明 path（本例没有）
 * 2、仅游客可访问的路由，声明 path
 * 3、如果已登录，渲染仅成员可访问的路由，不声明 path
 * 4、游客的 fallback 路由，不声明 path
 */
export default function AppRoutes() {
  const { profile } = useReadyInfo();

  return (
    <Switch>
      {/* 在开发环境，可以使用 /error 路由来检视错误提示页 */}
      {process.env.NODE_ENV === 'development' && <Route path="/error" component={ErrorView} />}
      <BasicRoute path="/login" component={AuthRoutes} />
      {profile && profile?.user_name && profile?.role && <ProtectedRoutes />}
      <GuestFallback />
    </Switch>
  );
}
